import type { CSS } from '@grupoboticario/flora-react'

export const fieldGroupCss: CSS = {
  marginBottom: '$7'
}
